import axios from "axios";
import React, { Component } from "react";
import Modal from "react-bootstrap/Modal";
import FeatherIcon from "feather-icons-react";
import UserprofileForm from "../profiles/UserprofileForm";
import { toast } from "react-toastify";

const STAFF_FIELD_RULES = {
  last_name: { step: 0, label: "Le nom", required: true, minLength: 2, maxLength: 50 },
  first_name: { step: 0, label: "Le pr\u00e9nom", maxLength: 50 },
  family_name: { step: 0, label: "Le post-nom", maxLength: 50 },
  marital_status: { step: 0, label: "L'\u00e9tat civil", maxLength: 20 },
  genre: { step: 0, label: "Le genre", maxLength: 10 },
  identity_number: { step: 0, label: "Le num\u00e9ro d'identit\u00e9", maxLength: 50 },
  email: { step: 0, label: "L'adresse e-mail", maxLength: 80 },
  tel: { step: 0, label: "Le t\u00e9l\u00e9phone", exactLength: 9, maxLength: 9 },
  nationality: { step: 0, label: "La nationalit\u00e9", maxLength: 100 },
  matricule: { step: 1, label: "Le matricule", maxLength: 50 },
  diploma: { step: 1, label: "Le dipl\u00f4me", maxLength: 50 },
  seniority: { step: 1, label: "L'anciennet\u00e9", maxLength: 50 },
};

class StaffForm extends Component {
  state = {
    id: "",
    matricule: "",
    first_name: "",
    last_name: "",
    family_name: "",
    genre: "",
    email: "",
    tel: "",
    identity_number: "",
    datebirth: "",
    datebirth_display: "",
    nationality: "",
    diploma: "",
    seniority: "",
    date_function: "",
    date_function_display: "",
    commitment_date: "",
    commitment_date_display: "",
    marital_status: "",
    salary: "",
    profiles: [],
    errors: {},
    error: "",
    title: "",
    currentStep: 0,
    btn: false,
  };

  handleInput = (e) => {
    const { name, value } = e.target;
    this.setState((state) => ({
      [name]: value,
      error: "",
      errors: { ...state.errors, [name]: "" },
    }));
  };

  isValidIsoDate = (value) => {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return false;
    const [year, month, day] = value.split("-").map(Number);
    const date = new Date(Date.UTC(year, month - 1, day));
    return date.getUTCFullYear() === year && date.getUTCMonth() === month - 1 && date.getUTCDate() === day;
  };

  formatDateIso = (value) => {
    if (!value) return "";
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return "";

    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    return `${date.getFullYear()}-${month}-${day}`;
  };

  formatDateFr = (value) => {
    if (!value) return "";
    const iso = this.formatDateIso(value);
    if (!iso) return "";

    const [year, month, day] = iso.split("-");
    return `${day}/${month}/${year}`;
  };

  parseDateFrToIso = (value) => {
    if (!value) return "";

    const cleanValue = value.replace(/[^\d/]/g, "");
    const parts = cleanValue.split("/");

    if (parts.length !== 3) return "";

    const [day, month, year] = parts;

    if (day.length !== 2 || month.length !== 2 || year.length !== 4) return "";

    const isoValue = `${year}-${month}-${day}`;
    return this.isValidIsoDate(isoValue) ? isoValue : "";
  };

  handleDateFrInput = (e) => {
    const { name, value } = e.target;
    const displayName = `${name}_display`;
    const isoValue = this.parseDateFrToIso(value);

    this.setState((state) => ({
      [displayName]: value,
      [name]: isoValue || "",
      error: "",
      errors: { ...state.errors, [name]: "" },
    }));
  };

  goToStep = (currentStep) => {
    if (currentStep > this.state.currentStep) {
      const errors = this.validateStep(this.state.currentStep);
      if (Object.keys(errors).length) {
        this.setState({ errors, error: Object.values(errors)[0] });
        return;
      }
    }
    this.setState({ currentStep, error: "" });
  };

  validateStep = (step) => {
    const errors = {};

    Object.entries(STAFF_FIELD_RULES).forEach(([name, rule]) => {
      if (rule.step !== step) return;

      const value = String(this.state[name] || "").trim();
      if (rule.required && !value) {
        errors[name] = `${rule.label} est obligatoire.`;
      } else if (value && rule.exactLength && value.length !== rule.exactLength) {
        errors[name] = `${rule.label} doit contenir exactement ${rule.exactLength} caractères.`;
      } else if (value && rule.minLength && value.length < rule.minLength) {
        errors[name] = `${rule.label} doit contenir au moins ${rule.minLength} caractères.`;
      } else if (value && rule.maxLength && value.length > rule.maxLength) {
        errors[name] = `${rule.label} ne peut pas dépasser ${rule.maxLength} caractères.`;
      }
    });

    if (step === 0) {
      if (this.state.datebirth_display && !this.state.datebirth) {
        errors.datebirth = "La date de naissance doit respecter le format jj/mm/aaaa.";
      }
    }

    if (step === 1) {
      if (this.state.commitment_date_display && !this.state.commitment_date) {
        errors.commitment_date = "La date d’engagement doit respecter le format jj/mm/aaaa.";
      }
      if (this.state.date_function_display && !this.state.date_function) {
        errors.date_function = "La date de fonction doit respecter le format jj/mm/aaaa.";
      }
      if (this.state.salary !== "") {
        const salary = Number(this.state.salary);
        if (!Number.isFinite(salary) || salary < 0) {
          errors.salary = "Le salaire doit être un nombre positif ou nul.";
        }
      }
    }
    return errors;
  };

  validate = () => {
    const identityErrors = this.validateStep(0);
    const functionErrors = this.validateStep(1);
    return {
      errors: { ...identityErrors, ...functionErrors },
      firstStep: Object.keys(identityErrors).length ? 0 : 1,
    };
  };

  profiles = (profile = false) => {
    this.setState({ profiles: profile });
  };

  edit = () => {
    this.form();
  };

  form = () => {
    const data = this.props.formData;

    const datebirth = data?.user?.datebirth ? this.formatDateIso(data.user.datebirth) : "";
    const commitment_date = data?.commitment_date ? this.formatDateIso(data.commitment_date) : "";
    const date_function = data?.date_function ? this.formatDateIso(data.date_function) : "";

    this.setState({
      id: data ? data.id : "",
      matricule: data ? data.matricule || "" : "",
      first_name: data ? data.user?.first_name || "" : "",
      last_name: data ? data.user?.last_name || "" : "",
      family_name: data ? data.user?.family_name || "" : "",
      genre: data ? data.user?.genre || "" : "",
      email: data ? data.user?.email || "" : "",
      tel: data ? data.user?.tel || "" : "",
      identity_number: data ? data.user?.identity_number || "" : "",
      nationality: data ? data.user?.nationality || "" : "",
      marital_status: data ? data.user?.marital_status || "" : "",
      diploma: data ? data.diploma || "" : "",
      seniority: data ? data.seniority || "" : "",
      salary: data?.salary ?? "",

      datebirth,
      datebirth_display: this.formatDateFr(datebirth),

      commitment_date,
      commitment_date_display: this.formatDateFr(commitment_date),

      date_function,
      date_function_display: this.formatDateFr(date_function),

      title: data ? "Modifier les informations du personnel" : "Ajouter un membre du personnel",
      errors: {},
      error: "",
      currentStep: 0,
      btn: false,
    });
  };

  storeStaff = () => {
    const { errors, firstStep } = this.validate();
    if (Object.keys(errors).length) {
      this.setState({ errors, error: Object.values(errors)[0], currentStep: firstStep });
      return;
    }

    const clean = (value) => String(value || "").trim();
    const data = {
      user: {
        first_name: clean(this.state.first_name) || null,
        last_name: clean(this.state.last_name),
        family_name: clean(this.state.family_name) || null,
        genre: clean(this.state.genre) || null,
        email: clean(this.state.email) || null,
        tel: clean(this.state.tel) || null,
        identity_number: clean(this.state.identity_number) || null,
        datebirth: this.state.datebirth || null,
        nationality: clean(this.state.nationality) || null,
        marital_status: clean(this.state.marital_status) || null,
      },
      profiles: this.state.profiles,
      staff: {
        matricule: clean(this.state.matricule) || null,
        diploma: clean(this.state.diploma) || null,
        seniority: clean(this.state.seniority) || null,
        date_function: this.state.date_function || null,
        commitment_date: this.state.commitment_date || null,
        salary: this.state.salary === "" ? null : Number(this.state.salary),
        operation: this.state.id ? "Editer" : "Ajouter",
        password: "123@Evivesoma", // Default password for new staff
      },
    };

    this.setState({ btn: true, errors: {}, error: "" });

    const request = this.state.id
      ? axios.put("staffs/" + this.state.id, data)
      : axios.post("staffs", data);

    request
      .then((response) => {
        this.setState({ btn: false });
        this.props.showModal();
        this.form();

        toast(response?.data?.msg, {
          theme: "light",
          style: { backgroundColor: "blue", color: "white" },
        });
      })
      .catch((error) => {
        const serverErrors = error.response?.data?.errors || {};
        const message = error.response?.data?.msg || Object.values(serverErrors)[0] || "Une erreur est survenue";
        this.setState({
          btn: false,
          errors: serverErrors,
          error: message,
        });

        toast(message, {
          theme: "light",
          style: { backgroundColor: "red", color: "white" },
        });
      });
  };

  renderInput = ({
    label,
    name,
    type = "text",
    icon,
    required = STAFF_FIELD_RULES[name]?.required || false,
    col = "col-md-4",
    maxLength = STAFF_FIELD_RULES[name]?.maxLength,
    minLength = STAFF_FIELD_RULES[name]?.minLength,
    min,
  }) => (
    <div className={`${col} mt-2`} key={name}>
      <div className="form-group has-icon-left">
        <label className="font-monospace fw-normal">
          {label}
          {required && <span className="text-danger">*</span>}
        </label>

        <div className="position-relative mt-1">
          <input
            type={type}
            className={`form-control form-control-sm ${this.state.errors[name] ? "is-invalid" : ""}`}
            name={name}
            value={this.state[name] || ""}
            onChange={this.handleInput}
            required={required}
            minLength={minLength}
            maxLength={maxLength}
            min={min}
            aria-required={required}
            aria-invalid={Boolean(this.state.errors[name])}
          />

          <div className="form-control-icon text-secondary">
            <FeatherIcon icon={icon} />
          </div>
        </div>
        {this.state.errors[name] && <small className="text-danger">{this.state.errors[name]}</small>}
      </div>
    </div>
  );

  renderDateInput = ({ label, name, icon = "calendar", required = false, col = "col-md-4" }) => (
    <div className={`${col} mt-2`} key={name}>
      <div className="form-group has-icon-left">
        <label className="font-monospace fw-normal">
          {label}
          {required && <span className="text-danger">*</span>}
        </label>

        <div className="position-relative mt-1">
          <input
            type="text"
            inputMode="numeric"
            className={`form-control form-control-sm ${this.state.errors[name] ? "is-invalid" : ""}`}
            placeholder="jj/mm/aaaa"
            name={name}
            value={this.state[`${name}_display`] || ""}
            onChange={this.handleDateFrInput}
            maxLength={10}
            aria-invalid={Boolean(this.state.errors[name])}
          />

          <div className="form-control-icon text-secondary">
            <FeatherIcon icon={icon} />
          </div>
        </div>
        {this.state.errors[name] && <small className="text-danger">{this.state.errors[name]}</small>}
      </div>
    </div>
  );

  render() {
    const maritalOptions = ["Célibataire", "Marié(e)", "Divorcé(e)", "Veuf(ve)", "Autre"];

    return (
      <div>
        <Modal
          show={this.props.isModal}
          onHide={this.props.showModal}
          size="lg"
          dialogClassName="ev-form-dialog"
          contentClassName="ev-form-modal ev-form-modal--compact"
          onEntered={this.edit}
          backdrop="static"
        >
          <Modal.Header>
            <div className="ev-form-heading">
              <span className="ev-form-heading__icon">
                <FeatherIcon icon="briefcase" size="20" />
              </span>

              <div>
                <span className="ev-form-heading__eyebrow">Dossier personnel</span>
                <Modal.Title>{this.state.title}</Modal.Title>
              </div>
            </div>
          </Modal.Header>

          <Modal.Body className="row ev-form-body">
            {this.state.error && (
              <div className="col-12">
                <div className="ev-form-alert" role="alert">
                  <FeatherIcon icon="alert-circle" size="17" />
                  <span>{this.state.error}</span>
                </div>
              </div>
            )}

            <div className="col-12 ev-form-stepper" aria-label={`Étape ${this.state.currentStep + 1} sur 3`}>
              <div className="ev-form-stepper__track">
                <span style={{ width: `${((this.state.currentStep + 1) / 3) * 100}%` }} />
              </div>

              {["Identité", "Fonction", "Profils et accès"].map((label, index) => (
                <button
                  type="button"
                  key={label}
                  className={`${index === this.state.currentStep ? "is-active" : ""} ${
                    index < this.state.currentStep ? "is-complete" : ""
                  }`}
                  onClick={() => this.goToStep(index)}
                >
                  <span>
                    {index < this.state.currentStep ? <FeatherIcon icon="check" size="14" /> : index + 1}
                  </span>
                  <small>{label}</small>
                </button>
              ))}
            </div>

            {this.state.currentStep === 0 && (
              <>
                <div className="col-12 ev-form-section">
                  <span>
                    <FeatherIcon icon="user" size="16" />
                  </span>
                  <div>
                    <strong>Identité du membre</strong>
                    <small>Nom, contact, genre et informations administratives</small>
                  </div>
                </div>

                {this.renderInput({
                  label: "Nom",
                  name: "last_name",
                  icon: "user-plus",
                  required: true,
                  maxLength: 50,
                })}

                {this.renderInput({
                  label: "Prénom",
                  name: "first_name",
                  icon: "user-plus",
                  maxLength: 50,
                })}

                {this.renderInput({
                  label: "Post-nom",
                  name: "family_name",
                  icon: "user-plus",
                  maxLength: 50,
                })}

                {this.renderInput({
                  label: "Email",
                  name: "email",
                  type: "email",
                  icon: "mail",
                  maxLength: 80,
                })}

                {this.renderInput({
                  label: "Téléphone",
                  name: "tel",
                  type: "number",
                  icon: "phone-call",
                  maxLength: 9,
                })}

                {this.renderInput({
                  label: "N° d'identité",
                  name: "identity_number",
                  type: "text",
                  icon: "trello",
                  maxLength: 50,
                })}

                {this.renderInput({
                  label: "Nationalité",
                  name: "nationality",
                  icon: "flag",
                  maxLength: 100,
                })}

                {this.renderDateInput({
                  label: "Date de naissance",
                  name: "datebirth",
                })}

                <div className="col-md-4 mt-2">
                  <label className="font-monospace fw-normal">
                    Genre
                  </label>

                  <div className="ev-choice-group">
                    <label className="ev-choice" htmlFor="staff-masculin">
                      <input
                        id="staff-masculin"
                        type="radio"
                        name="genre"
                        value="Masculin"
                        checked={this.state.genre === "Masculin"}
                        onChange={this.handleInput}
                      />
                      <span>Masculin</span>
                    </label>

                    <label className="ev-choice" htmlFor="staff-feminin">
                      <input
                        id="staff-feminin"
                        type="radio"
                        name="genre"
                        value="Feminin"
                        checked={this.state.genre === "Feminin"}
                        onChange={this.handleInput}
                      />
                      <span>Féminin</span>
                    </label>
                  </div>
                </div>

                <div className="col-md-8 mt-2">
                  <label className="font-monospace fw-normal">État civil</label>

                  <div className="ev-choice-group">
                    {maritalOptions.map((status) => (
                      <label className="ev-choice" htmlFor={`staff-marital-${status}`} key={status}>
                        <input
                          id={`staff-marital-${status}`}
                          type="radio"
                          name="marital_status"
                          value={status}
                          checked={this.state.marital_status === status}
                          onChange={this.handleInput}
                        />
                        <span>{status}</span>
                      </label>
                    ))}
                  </div>
                </div>
              </>
            )}

            {this.state.currentStep === 1 && (
              <>
                <div className="col-12 ev-form-section">
                  <span>
                    <FeatherIcon icon="briefcase" size="16" />
                  </span>
                  <div>
                    <strong>Fonction et engagement</strong>
                    <small>Matricule, diplôme, ancienneté, salaire et dates importantes</small>
                  </div>
                </div>

                {this.renderInput({
                  label: "N° matricule",
                  name: "matricule",
                  icon: "trello",
                  maxLength: 50,
                })}

                {this.renderInput({
                  label: "Diplôme",
                  name: "diploma",
                  icon: "file",
                  maxLength: 50,
                })}

                {this.renderInput({
                  label: "Ancienneté",
                  name: "seniority",
                  icon: "box",
                  maxLength: 50,
                })}

                {this.renderInput({
                  label: "Salaire mensuel",
                  name: "salary",
                  type: "number",
                  icon: "dollar-sign",
                  min: 0,
                })}

                {this.renderDateInput({
                  label: "Date engagement",
                  name: "commitment_date",
                })}

                {this.renderDateInput({
                  label: "Date entrée en fonction",
                  name: "date_function",
                })}
              </>
            )}

            {this.state.currentStep === 2 && (
              <>
                <div className="col-12 ev-form-section">
                  <span>
                    <FeatherIcon icon="shield" size="16" />
                  </span>
                  <div>
                    <strong>Profils et accès</strong>
                    <small>Attribuer les profils correspondant aux responsabilités réelles</small>
                  </div>
                </div>

                <div className="col-12 ev-form-profile staff-profile-line mt-2">
                  <UserprofileForm profiles={this.profiles} model="Staff" />
                </div>
              </>
            )}
          </Modal.Body>

          <Modal.Footer>
            <span className="ev-form-footer-note">
              <FeatherIcon icon="info" size="14" /> Les champs marqués d’un * sont obligatoires
            </span>

            <button type="button" onClick={this.props.showModal} className="btn btn-light ev-form-button">
              <FeatherIcon icon="x" size="16" /> Fermer
            </button>

            {this.state.currentStep > 0 && (
              <button
                type="button"
                onClick={() => this.goToStep(this.state.currentStep - 1)}
                className="btn btn-light ev-form-button"
              >
                <FeatherIcon icon="arrow-left" size="16" /> Précédent
              </button>
            )}

            {this.state.currentStep < 2 && (
              <button
                type="button"
                onClick={() => this.goToStep(this.state.currentStep + 1)}
                className="btn btn-primary ev-form-button"
              >
                Suivant <FeatherIcon icon="arrow-right" size="16" />
              </button>
            )}

            {this.state.currentStep === 2 && (
              <button
                type="button"
                onClick={this.storeStaff}
                disabled={this.state.btn}
                className="btn btn-primary ev-form-button"
              >
                <FeatherIcon icon="check" size="16" />
                {this.state.btn ? "Enregistrement..." : "Sauvegarder"}
              </button>
            )}
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default StaffForm;
